import { Controller } from "stimulus";
export default class extends Controller {
    static targets = ["newGuideButton", "guideForm"]

    triggerForm() {
        this.guideFormTarget.classList.toggle('hidden');
        this.newGuideButtonTarget.classList.toggle('hidden');
    }
}